module.exports = __webpack_public_path__ + "img/electric_enabled.8f78034e.svg";